'use client';

import React from 'react';
import { Flex } from '../Flex';
import { Typography } from '../Typography';
import { useSegmentTrack } from '../../hooks/useSegmentTrack';
import { healthArticleArticleCostCTASegment } from '../../data/segment/health-article-segment';
import { generatePetInsuranceUrlWithQueryParams } from '../../utils/generatePetInsuranceUrlWithQueryParams';
import graphBackground from './assets/bg-graph.svg';
import caretRightWhite from '../../assets/icons/caret-right-white.svg';
import pawIconWellness from '../../assets/icons/paw-icon-wellness.svg';
import { UTMTerm } from '../../constants/query-string-values';
import { HealthArticleProps } from '../HealthArticle';
import { Box } from '../../wag-react/next-components/box';
import { Button } from '../../wag-react/next-components/button';
import { Icon } from '../../wag-react/components/icon';
export type ArticleCostValue = {
  title: string;
  avgCost: string;
  lowCost: string;
  highCost: string;
} & {
  numQuotes: number;
};
type Props = {
  value: Partial<ArticleCostValue>;
  utmMeta: Pick<HealthArticleProps, 'slug' | 'articleType'>;
};
export const ArticleCost = ({
  value: {
    title,
    lowCost,
    highCost,
    avgCost,
    numQuotes
  },
  utmMeta
}: Props) => {
  const {
    execute: executeSegmentTrack
  } = useSegmentTrack();
  const handleClick = () => {
    const petInsuranceQuoteWithQueryParams = generatePetInsuranceUrlWithQueryParams(UTMTerm.CostGraph, utmMeta.slug, utmMeta.articleType);
    window.open(petInsuranceQuoteWithQueryParams, '_blank');
    executeSegmentTrack({
      data: healthArticleArticleCostCTASegment
    });
  };
  return <Flex alignItems="center" flexDirection="column" mb="10px" data-sentry-element="Flex" data-sentry-component="ArticleCost" data-sentry-source-file="index.tsx">
      <Flex flexDirection="column" alignItems="start" width={1} maxWidth="344px" height="188px" borderRadius={['unset', '16px']} boxShadow={['unset', '0 2px 4px 2px rgba(0, 0, 0, .09)']} overflow="hidden" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Box p="20px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Typography fontWeight="bold" fontSize="12px" mt={0} mb="4px" style={{
          textTransform: 'uppercase'
        }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            {title}
          </Typography>
          <Typography fontSize="12px" color="#9b9b9b" m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            {`From ${numQuotes} quotes ranging from $${lowCost} - $${highCost}`}
          </Typography>
        </Box>
        <Box flexDirection="column" alignItems="center" backgroundImage={`url(${graphBackground})`} backgroundSize="contain" backgroundRepeat="no-repeat" backgroundPosition="bottom" position="relative" width={1} height="120px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Box as="span" position="absolute" top="50%" m="-2px auto 0" width={1} height="2px" backgroundColor="wagGreen" textAlign="center" data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <Typography m={0} fontSize="12px" fontWeight="bold" style={{
            textTransform: 'uppercase',
            top: '-30px',
            position: 'relative'
          }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              Average Cost
            </Typography>
            <Typography display="inline-block" backgroundColor="wagGreen" fontSize="16px" fontWeight="bold" px="10px" color="white" style={{
            borderRadius: '16px',
            top: '-24px',
            position: 'relative'
          }} m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              {`$${avgCost}`}
            </Typography>
          </Box>
        </Box>
      </Flex>
      <Button marginTop={['24px', '12px']} mb={[null, '20px']} onClick={handleClick} display="grid" maxWidth="344px" alignItems="center" justifyItems="center" data-sentry-element="Button" data-sentry-source-file="index.tsx">
        <Flex width={[1]} borderRadius="8px" flex={1} bg="wagGold" justifyItems="center" alignItems="center" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Icon src={pawIconWellness} width="28px" height="28px" ml="10px" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
          <Typography color="white" lineHeight="16px" fontFamily="muliBold" fontSize="14px" ml="10px" textAlign="left" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            Protect yourself and your pet.
            Compare top pet insurance plans.
          </Typography>
          <Icon src={caretRightWhite} width={['18px', '20px']} height={['18px', '20px']} mr="10px" ml="10px" justifySelf="center" alignSelf="center" color="white" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
        </Flex>
      </Button>
    </Flex>;
};
export type ArticleCostProps = Props;